<template>
  <base-row
    v-bind="$props"
    :selectable="false"
  >
    <td>
      <Link
        v-if="hasRoute"
        :href="showOrderRoute"
        class="uppercase font-semibold text-blue-600 hover:underline hover:text-blue-600 cursor-pointer"
      >
        {{ item.source_id || item.id }}
      </Link>
      <span
        v-else
        @click="emitClicked"
        class="text-blue-600 hover:text-blue-600 hover:underline cursor-pointer"
      >
        {{ item.source_id || item.id }}
      </span>
    </td>
    <td>
      {{ item.origin }}
    </td>
    <td>
      {{ _datetime(item.created_at) }}
    </td>
    <td>
      {{ item.item_count || '-' }}
    </td>
    <td>
      {{ _dollars(item.total) }}
    </td>
    <td>
      {{ item.display_status }}
    </td>
    <td>
      {{ item.fulfillment_status }}
    </td>
  </base-row>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import TableRow from '@/Components/Table/TableRow'
import RowProps from '@/Components/Table/Mixins/RowProps'
import BasicBadge from '@/Components/Badges/BasicBadge.vue'
import _datetime from '@/Filters/DateTime'
import _dollars from '@/Filters/Dollars'

export default {
  components: {
    'base-row': TableRow,
    Link,
    BasicBadge
  },

  mixins: [RowProps],

  emits: ['clicked'],

  props: {
    /**
     * A function that we can use to generate the URL to view a package. Returns a string that is a valid URL
     */
    showRoute: {
      type: Function,
      default: (item) => null
    }
  },

  computed: {
    /**
     * Returns the URL we can use to view a package
     */
    showOrderRoute() {
      return this.showRoute(this.item)
    },

    /**
     * Returns true if this package has a valid URL to view a package
     * @returns {boolean}
     */
    hasRoute() {
      return this.showOrderRoute !== null
    }
  },
  methods: {
    _datetime,
    _dollars,

    emitClicked() {
      this.$emit('clicked', this.item)
    }
  }
}
</script>
